import actions from './actions';

const {
  TASK_ADD_BEGIN,
  TASK_ADD_SUCCESS,
  TASK_ADD_ERR,

  TASK_READ_BEGIN,
  TASK_READ_SUCCESS,
  TASK_READ_ERR,

  TASKINFO_READ_BEGIN,
  TASKINFO_READ_SUCCESS,
  TASKINFO_READ_ERR,


  TASK_UPDATE_BEGIN,
  TASK_UPDATE_SUCCESS,
  TASK_UPDATE_ERR,

  ASSIGNED_TASKS_READ_BEGIN,
  ASSIGNED_TASKS_READ_SUCCESS,
  ASSIGNED_TASKS_READ_ERR,

  SINGLE_TASK_READ_BEGIN,
  SINGLE_TASK_READ_SUCCESS,
  SINGLE_TASK_READ_ERR,

  ASSIGNED_TASK_TO_PERSON_BEGIN,
  ASSIGNED_TASK_TO_PERSON_SUCCESS,
  ASSIGNED_TASK_TO_PERSON_ERR,

  GET_TASKS_BY_USER_READ_BEGIN,
  GET_TASKS_BY_USER_READ_SUCCESS,
  GET_TASKS_BY_USER_READ_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const singleTaskInitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const getTasksByUserInitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const assignedTasksinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const assignTaskToPersoninitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const updateStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const TASKReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TASK_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TASK_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TASK_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const GETTasksByUserReducer = (state = getTasksByUserInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_TASKS_BY_USER_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_TASKS_BY_USER_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_TASKS_BY_USER_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const SINGLETaskReducer = (state = singleTaskInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SINGLE_TASK_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case SINGLE_TASK_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case SINGLE_TASK_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const ASSIGNTaskToPersonReducer = (state = assignTaskToPersoninitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ASSIGNED_TASK_TO_PERSON_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ASSIGNED_TASK_TO_PERSON_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case ASSIGNED_TASK_TO_PERSON_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const ASSIGNEDTasksReducer = (state = assignedTasksinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ASSIGNED_TASKS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ASSIGNED_TASKS_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case ASSIGNED_TASKS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const TASKAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TASK_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TASK_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TASK_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };


    default:
      return state;
  }
};

const TASKUpdateReducer = (state = updateStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {

    case TASK_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TASK_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TASK_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const TASKINFOReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TASKINFO_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TASKINFO_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TASKINFO_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export {
  GETTasksByUserReducer, ASSIGNTaskToPersonReducer, TASKReducer, TASKUpdateReducer,
  TASKAddReducer, ASSIGNEDTasksReducer, SINGLETaskReducer, TASKINFOReducer
};
